import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrderTypeRadioGroupComponent } from './order-type-radio-group.component';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [OrderTypeRadioGroupComponent],
  imports: [CommonModule, TranslocoModule],
  exports: [OrderTypeRadioGroupComponent]
})
export class OrderTypeRadioGroupComponentModule {}
